import { useEffect, useState } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend } from "recharts";
import { api } from "@/lib/api";

const MARGIN = { left: 10 };
const RADIUS = [0, 6, 6, 0];
const INITIAL_DIMENSION = { width: 320, height: 256 };
const TICK = { fontSize: 11, fill: "var(--mm-text-secondary)" };

export const EmotionTrends = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/insights/emotions").then((r) => setD(r.data)).catch(() => setD({ this_week: [] })); }, []);
  if (!d) return null;
  const top = d.this_week[0];
  return (
    <div className="mm-card p-5" data-testid="emotion-trends">
      <h3 className="font-semibold">Your top emotions this week</h3>
      {top ? (
        <>
          <p className="text-sm text-mm-muted mt-1" data-testid="emotion-trends-top">Most often: <span className="font-semibold text-mm-text">{top.name}</span> ({top.count}×{top.prev ? `, ${top.prev}× last week` : ", new this week"})</p>
          <div className="h-64 mt-3">
            <ResponsiveContainer width="100%" height="100%" minWidth={0} initialDimension={INITIAL_DIMENSION}>
              <BarChart data={d.this_week} layout="vertical" margin={MARGIN}>
                <XAxis type="number" allowDecimals={false} tick={TICK} />
                <YAxis type="category" dataKey="name" width={110} tick={TICK} />
                <Tooltip />
                <Legend />
                <Bar dataKey="count" name="This week" fill="var(--mm-primary)" radius={RADIUS} />
                <Bar dataKey="prev" name="Last week" fill="var(--mm-border)" radius={RADIUS} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </>
      ) : <p className="text-sm text-mm-muted mt-2" data-testid="emotion-trends-empty">Pick emotions in your check-ins or journal this week to see them here.</p>}
    </div>
  );
};

export const BestSkills = ({ skills }) => {
  const list = skills?.best_skills || [];
  return (
    <div className="mm-card p-5" data-testid="best-skills">
      <h3 className="font-semibold">Skills that help most</h3>
      <p className="text-xs text-mm-muted mt-1">Average stress drop, for skills you've used at least twice</p>
      {list.length ? (
        <ol className="mt-3 space-y-2">
          {list.map((s, i) => (
            <li key={s.skill_id} className={`flex items-center justify-between gap-3 p-3 rounded-xl ${i === 0 ? "mm-soft" : ""}`} data-testid={`best-skill-${i}`}>
              <div>
                <div className="font-semibold text-sm">{s.skill_name}</div>
                <div className="text-xs text-mm-muted">{s.usage_count} uses{i === 0 ? " · reach for this first" : ""}</div>
              </div>
              <span className={`font-display font-bold ${s.avg_stress_reduction > 0 ? "text-mm-success" : "text-mm-muted"}`}>
                {s.avg_stress_reduction > 0 ? `−${s.avg_stress_reduction}` : s.avg_stress_reduction}
              </span>
            </li>
          ))}
        </ol>
      ) : <p className="text-sm text-mm-muted mt-2" data-testid="best-skills-empty">Use a coping skill at least twice (with the before/after stress check) to see what works best for you.</p>}
    </div>
  );
};
